module.exports = __webpack_public_path__ + "images/sp/common/tel_btn_3439d5dd4da33ced5138609a8b6a02af.png";